<script setup lang="ts" name="FormWizardHorizontalTabTitle">
defineProps<{
  title: string;
  isActive: boolean;
  isCompleted: boolean;
  disabled?: boolean;
}>();
</script>

<template>
  <div
    class="text-button-2 uppercase"
    :class="{
      'text-charcoal-5': disabled,
      'text-primary-8': isActive,
      'text-primary-6': isCompleted && !disabled,
      'text-charcoal-6': !isCompleted && !disabled,
    }"
  >
    {{ title }}
  </div>
</template>
